import script from "./CardFormCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./CardFormCompleted.vue?vue&type=script&setup=true&lang=js"

import "./CardFormCompleted.vue?vue&type=style&index=0&id=721d5d7f&lang=scss&scoped=true"

import exportComponent from "C:\\Frontend\\Projects\\interactive-card-details-form-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-721d5d7f"]])

export default __exports__